<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <side-bar class="scroll-box" :background-color="sidebarBackground">
      <template>
        <v-list nav class="py-12">
          <v-list-item :to="{ path : '/dashboard'}">
            <v-list-item-icon class="list-item-icon">
              <img src="@/assets/images/Home.svg" />
            </v-list-item-icon>
            <v-list-item-title class="list-item-name">Dashboard</v-list-item-title>
          </v-list-item>

          <v-list-group class="list-group-box" no-action>
            <template v-slot:activator>
              <v-list-item-icon class="list-item-icon">
                <img src="@/assets/images/Home.svg" />
              </v-list-item-icon>
              <v-list-item-title class="list-item-name">Home</v-list-item-title>
            </template>

            <v-list-item v-for="(list, i) in home" :key="i" :to="{ path : list.path}">
              <v-list-item-icon>
                <img :src="list.icon" />
              </v-list-item-icon>
              <v-list-item-title  class="list-item-name" v-text="list.text"></v-list-item-title>
            </v-list-item>
          </v-list-group>

           <v-list-group class="list-group-box" no-action>
            <template v-slot:activator>
              <v-list-item-icon class="list-item-icon">
                <img src="@/assets/images/Newsfeed.svg" />
              </v-list-item-icon>
              <v-list-item-title class="list-item-name">News & Articles</v-list-item-title>
            </template>

            <v-list-item v-for="(list, i) in news" :key="i" :to="{ path : list.path}">
              <v-list-item-icon>
                <img :src="list.icon" />
              </v-list-item-icon>
              <v-list-item-title class="list-item-name" v-text="list.text"></v-list-item-title>
            </v-list-item>
          </v-list-group>

           <v-list-group class="list-group-box" no-action>
            <template v-slot:activator>
              <v-list-item-icon class="list-item-icon">
                <img src="@/assets/images/Product.svg" />
              </v-list-item-icon>
              <v-list-item-title class="list-item-name">Products</v-list-item-title>
            </template>

            <v-list-item v-for="(list, i) in productList" :key="i" :to="{ path : list.path}">
              <v-list-item-icon>
                <img :src="list.icon" />
              </v-list-item-icon>
              <v-list-item-title class="list-item-name" v-text="list.text"></v-list-item-title>
            </v-list-item>
          </v-list-group>

           <v-list-group class="list-group-box" no-action>
            <template v-slot:activator>
              <v-list-item-icon class="list-item-icon">
                <img src="@/assets/images/Community.svg" />
              </v-list-item-icon>
              <v-list-item-title class="list-item-name">Community</v-list-item-title>
            </template>

            <v-list-item v-for="(list, i) in community" :key="i" :to="{ path : list.path}">
              <v-list-item-icon>
                <img :src="list.icon" />
              </v-list-item-icon>
              <v-list-item-title  class="list-item-name" v-text="list.text"></v-list-item-title>
            </v-list-item>
          </v-list-group>

          <v-list-group class="list-group-box" no-action>
            <template v-slot:activator>
              <v-list-item-icon class="list-item-icon">
                <img src="@/assets/images/Education.svg" />
              </v-list-item-icon>
              <v-list-item-title class="list-item-name">Education</v-list-item-title>
            </template>

            <v-list-item v-for="(list, i) in education" :key="i" :to="{ path : list.path}">
              <v-list-item-icon>
                <img :src="list.icon" />
              </v-list-item-icon>
              <v-list-item-title  class="list-item-name" v-text="list.text"></v-list-item-title>
            </v-list-item>
          </v-list-group>

          <v-list-item :to="{ path : '/users'}">
            <v-list-item-icon class="list-item-icon">
              <img src="@/assets/images/User.svg" />
            </v-list-item-icon>
            <v-list-item-title class="list-item-name">User Management</v-list-item-title>
          </v-list-item>

           <v-list-item :to="{ path : '/roles'}" v-if="userType === 'super'">
            <v-list-item-icon class="list-item-icon">
              <img src="@/assets/images/Role.svg" />            
            </v-list-item-icon>
            <v-list-item-title class="list-item-name">Role Management</v-list-item-title>
          </v-list-item>

          <v-list-item :to="{ path : '/notifications'}">
            <v-list-item-icon class="list-item-icon">
              <img src="@/assets/images/List.svg" />
            </v-list-item-icon>
            <v-list-item-title class="list-item-name">Activity Logs</v-list-item-title>
          </v-list-item>

          <v-list-group class="list-group-box" no-action>
            <template v-slot:activator>
              <v-list-item-icon class="list-item-icon">
                <img src="@/assets/images/Setting.svg" />
              </v-list-item-icon>
              <v-list-item-title class="list-item-name">Settings</v-list-item-title>
            </template>

            <v-list-item v-for="(list, i) in settings" :key="i" :to="{ path : list.path}">
              <v-list-item-icon>
                <img :src="list.icon" />
              </v-list-item-icon>
              <v-list-item-title class="list-item-name" v-text="list.text"></v-list-item-title>
            </v-list-item>
          </v-list-group>

          <v-list-item @click="logout">
            <v-list-item-icon class="list-item-icon">
              <img src="@/assets/images/Logout.svg" />
            </v-list-item-icon>
            <v-list-item-title class="list-item-name">Log out</v-list-item-title>
          </v-list-item>
        </v-list>
      </template>
    </side-bar>
    <div class="main-content" :data="sidebarBackground">
      <div @click="toggleSidebar">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
        <content-footer style="margin-left:300px" v-if="!$route.meta.hideFooter"></content-footer>
      </div>
    </div>
  </div>
</template>

<script>
import ContentFooter from "./ContentFooter.vue";
import { FadeTransition } from "vue2-transitions";
import { AuthService } from "@/services";
import store from "@/store";

export default {
  components: {
    ContentFooter,
    FadeTransition,
  },
  data() {
    return {
      sidebarBackground: "blue", //vue|blue|orange|green|red|primary,
      item: 1,
      userType: null,
      productList: [
        {
          icon: require('@/assets/images/List.svg'),
          text: "List / Availability",
          path: "/products"
        },
        {
          icon: require('@/assets/images/Manufacturer.svg'),
          text: "Manufacturers",
          path: "/manufacturer"
        },
        
      ],
      news: [
        {
          icon: require('@/assets/images/List.svg'),
          text: "News & Articles List",
          path: "/news-feed"
        },
        {
          icon: require('@/assets/images/Category.svg'),
          text: "Category",
          path: "/news-category"
        },
      ],
      community: [
        {
          icon: require('@/assets/images/Community.svg'),
          text: "Communities",
          path: "/community"
        },
        {
          icon: require('@/assets/images/Requests.svg'),
          text: "Requests",
          path: "/requests"
        }
      ],
      education: [
        // {
        //   icon: require('@/assets/images/List.svg'),
        //   text: "Journal Club",
        //   path: "/journal-club"
        // },
        {
          icon: require('@/assets/images/clinic.svg'),
          text: "Clinic",
          path: "/clinic"
        },
        {
          icon: require('@/assets/images/List.svg'),
          text: "LP Profiles",
          path: "/lp-profile"
        },
        {
          icon: require('@/assets/images/List.svg'),
          text: "Library",
          path: "/library"
        },
        {
          icon: require('@/assets/images/List.svg'),
          text: "FAQ",
          path: "/faq"
        },
      ],
      home: [
        {
          icon: require('@/assets/images/List.svg'),
          text: "Guide Card",
          path: "/guide-card"
        },
        {
          icon: require('@/assets/images/List.svg'),
          text: "Testimonial",
          path: "/testimonials"
        },
        {
          icon: require('@/assets/images/List.svg'),
          text: "Useful Link",
          path: "/useful-links"
        },
        {
          icon: require('@/assets/images/List.svg'),
          text: "Event Schedule",
          path: "/events"
        },
        // {
        //   icon: require('@/assets/images/List.svg'),
        //   text: "Upcoming Event",
        //   path: "/upcoming-event"
        // },
      ],
      settings:[
        {
          icon: require('@/assets/images/List.svg'),
          text: "Terpene Information",
          path: "/product-parameter"
        }
      ]
    };
  },
  created() {
    this.userType = store.state.user.user.userType;
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    async logout() {
      const response = await AuthService.logout();
      if (response) {
        this.$store.dispatch("user/setToken", null);
        this.$store.dispatch("user/setUser", null);
        this.$router.push({ name: "login" });
      }
    }
  }
};
</script>
<style lang="scss">
.wrapper {
  .navbar-vertical.navbar-expand-md {
    max-width: 300px !important;
  }
  .navbar-vertical.navbar-expand-md.fixed-left + .main-content {
    margin-left: 300px !important;
  }
}
.list-item-name {
  text-transform: uppercase;
  font-weight: 600;
  font-size: 16px;
  color: #344452;
}
.list-item-icon {
  margin-left: 8px !important;
  margin-right: 16px !important;
}
.scroll-box{
  overflow-y: auto;
  padding: 0 !important;
}
.list-group-box {
  margin-bottom: 8px;
}
</style>
